// extracted by mini-css-extract-plugin
export default {"container":"Gallery_container__XDD6l","gallery_title":"Gallery_gallery_title__QACjI"};